import React from "react";
import TabLabel from "./TabLabel";
import Sunnhet from "./Sunnhet";
import Indeks from "./Indeks";
import Mentalbeskrivelse from "./Mentalbeskrivelse";
import Statistikk from "./Statistikk";
import ElementHelp from "./ElementHelp";
import {withRouter, useHistory } from "react-router-dom";
import qs from "query-string";
import SunnhetUndersoekelser from "./SunnhetUndersoekelser";



const SunnhetAdferdStatistikk = (props) => {
    const hund = props.hund;
    const oeyeEcvoUndersoekelser = props.oeyeEcvoUndersoekelser;
    const roentgenUndersoekelser = props.roentgenUndersoekelser;
    const oeyeDnaUndersoekelser = props.oeyeDnaUndersoekelser;
    const dnaUndersoekelser = props.dnaUndersoekelser;
    const oevrigeUndersoekelser = props.oevrigeUndersoekelser;

    const uoffsielleSunnhetUndersoekelser = props.uoffsielleSunnhetUndersoekelser;

    const hdIndekser = props.hdIndekser;
    const ryggIndekser = props.ryggIndekser;

    const mentalbeskrivelse = props.mentalbeskrivelse;

    const avkomRoentgenStatistikk = props.avkomRoentgenStatistikk;
    const raseRoentgenStatistikk = props.raseRoentgenStatistikk;
    const barnebarnRoentgenStatistikk = props.barnebarnRoentgenStatistikk;

    let history = useHistory();
    const parsed = qs.parse(decodeURI(props.location.search));
    let tabId = 'sundhed';
    if (parsed.sundhedTab !== undefined) {
        tabId = parsed.sundhedTab;
    }

    const setTab = (t) => {
        let params = parsed;
        if (t !== tabId) {
            params.sundhedTab = t;
            if (t !== 'sundhed') {
                delete params.sundhedLabel;
            }
            if (t !== 'index') {
                delete params.indexLabel;
            }
            if (t !== 'statistik') {
                delete params.statistikLabel;
            }

        }
        delete params.stamLabel;
        delete params.query;
        delete params.antall;
        const currentPath = props.location.pathname;
        history.push(currentPath + "?" + qs.stringify(params));
    };


    const antallSunnhetSaker = () => {
        let antallSunnhetSaker = 0;
        antallSunnhetSaker = oeyeEcvoUndersoekelser.length;
        antallSunnhetSaker += roentgenUndersoekelser.length;
        antallSunnhetSaker += oeyeDnaUndersoekelser.length;
        antallSunnhetSaker += dnaUndersoekelser.length;
        antallSunnhetSaker += oevrigeUndersoekelser.length;
        return antallSunnhetSaker;
    };

    /*
    const antallUoffisielleSunnhetSaker = () => {
        if (uoffsielleSunnhetUndersoekelser != null) return uoffsielleSunnhetUndersoekelser.length;
        ret
    } */

    const antallMentalbeskrivelser = () => {
        if (mentalbeskrivelse !== null) {
            return 1;
        }
        return 0;
    }

    const show = (t) => {
        if (tabId === t) {
            return true;
        }
        return false;

    };

    const renderTabTitelClass = (t) => {
        if (tabId === t) {
            return "tabs-title tab-active";
        }
        return "tabs-title";
    };
    return (
        <div className="dogweb-box">
            <div className="dogweb-card-header">
                <div className="card-title">SUNDHED, ADFÆRD & STATISTIK </div>
                <div className="name-active-dog"> {hund.navn}</div>
                <ElementHelp slug={'sundhed'}/>
            </div>

            <div className="tab-container">
                <ul className="tabs">
                    <li className={renderTabTitelClass('sundhed')}>
                        <button onClick={() => setTab("sundhed")} >
                            <TabLabel name="SUNDHED" count={ antallSunnhetSaker() } />
                        </button>
                    </li>
                    <li className={renderTabTitelClass('index')}>
                        <button onClick={() => setTab("index")} >
                            <TabLabel name="INDEX" />
                        </button>
                    </li>
                    <li className={renderTabTitelClass('mental')}>
                        <button onClick={() => setTab("mental")} >
                            <TabLabel name="MENTALBESK" count={ antallMentalbeskrivelser() } />
                        </button>
                    </li>

                    <li className={renderTabTitelClass('statistik')}>
                        <button onClick={() => setTab("statistik")} >
                            <TabLabel name="STATISTIK" />
                        </button>
                    </li>
                    <li className={renderTabTitelClass('uofficiel-sundhed')}>
                        <button onClick={() => setTab("uofficiel-sundhed")} >
                            <TabLabel name="ANDEN SUNDHED" count={uoffsielleSunnhetUndersoekelser.length} />
                        </button>
                    </li>
                </ul>
                <div className="tabs-content">
                    <div className="tabs-panel is-active" >
                        {
                            show('sundhed') &&
                                <Sunnhet    roentgenUndersoekelser={roentgenUndersoekelser}
                                            oeyeEcvoUndersoekelser={oeyeEcvoUndersoekelser}
                                            oeyeDnaUndersoekelser={oeyeDnaUndersoekelser}
                                            dnaUndersoekelser={dnaUndersoekelser}
                                            oevrigeUndersoekelser={oevrigeUndersoekelser}
                                />
                        }
                        {
                            show('index') &&
                                <Indeks hund={hund} ryggIndekser={ryggIndekser} hdIndekser={hdIndekser}  />
                        }
                        {
                            show('mental') &&
                                <Mentalbeskrivelse mentalbeskrivelse={mentalbeskrivelse} />
                        }
                        {
                            show('statistik') &&
                                <Statistikk     avkomRoentgenStatistikk={avkomRoentgenStatistikk}
                                                barnebarnRoentgenStatistikk={barnebarnRoentgenStatistikk}
                                                raseRoentgenStatistikk={raseRoentgenStatistikk}
                                />
                        }
                        {
                            show('uofficiel-sundhed') &&
                            <SunnhetUndersoekelser undersoekelser={uoffsielleSunnhetUndersoekelser} uoffsielleSunnhetResultater={true} />
                        }
                    </div>
                </div>

            </div>
        </div>

    );
};

export default withRouter (SunnhetAdferdStatistikk);

